/**
 * Token storage using localStorage only.
 *
 * Cross-subdomain session handoff is done via URL fragment on main->subdomain
 * redirect (see LoginForm.tsx + AuthContextBackend.tsx subdomain bootstrap).
 * Tokens must NOT be stored in cookies — the browser would auto-attach them
 * alongside the Authorization header, doubling header size and causing 431.
 */

import { getBaseDomain } from './subdomain';

function deleteCookie(name: string): void {
  const baseDomain = getBaseDomain();
  document.cookie = `${name}=; path=/; max-age=0`;
  if (baseDomain) {
    document.cookie = `${name}=; path=/; domain=${baseDomain}; max-age=0`;
  }
}

export function getAccessToken(): string | null {
  return localStorage.getItem('access_token');
}

export function setAccessToken(token: string): void {
  localStorage.setItem('access_token', token);
}

export function getRefreshToken(): string | null {
  return localStorage.getItem('refresh_token');
}

export function setRefreshToken(token: string): void {
  localStorage.setItem('refresh_token', token);
}

export function clearTokens(): void {
  // Also scrub any .traineryhcm.com cookies left over from the earlier
  // cookie-mirror bug. Safe no-op if none exist.
  deleteCookie('access_token');
  deleteCookie('refresh_token');
  localStorage.removeItem('access_token');
  localStorage.removeItem('refresh_token');
}
